import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-highlighted-projects',
  imports: [
    MatCardModule,
    MatIconModule,
    MatListModule,
  ],
  templateUrl: './highlighted-projects.component.html',
  styleUrl: './highlighted-projects.component.scss'
})
export class HighlightedProjectsComponent {

}
